module.controller('signupCustomizeCtrl', [
  'cardOrderService', 'baseURI', '$state', '$scope', 'authService', 'localStorageService', 'referrerService',
  function(cardOrderService, baseURI, $state, $scope, authService, localStorageService, referrerService) {

  var vm = this;

  vm.cards = cardOrderService.getCards();
  vm.currentCard = cardOrderService.getCurrentCard();
  vm.nextStep = nextStep;

  init();
  if(vm.currentCard){
    vm.currentCard.Virtual = vm.currentCard.Virtual === true ? vm.currentCard.Virtual = 'on' : vm.currentCard.Virtual = 'off';
  }

  ///////////////////////////////

    function init() {
      $http.get(baseURI + 'card/physical?_key=' + encodeURIComponent($scope.brand.api_key))
        .then(function(resp){
          $scope.supportsPhysical = resp.data.Data.PhysicalProgram;
        })
        .catch(function(err){
        });

    if (vm.currentCard === undefined) {
      vm.currentCard = localStorageService.get('cardOrderCurrentCard');
      if (vm.currentCard) {
        vm.cards.push(vm.currentCard);
      } else {
        $state.go('signup.create');
      }
    }
  }

  function nextStep(isValid) {
    vm.submitted = true;
    vm.currentCard.Virtual = vm.currentCard.Virtual === 'on' ? true : false;

    if (isValid) {
      vm.submitted = false;
      if (authService.isAuthenticated()) {
        vm.loading = true;
        cardOrderService.addCard(vm.currentCard, false);
        $state.go('signup.order');
      } else {
        localStorageService.set('cardOrder', vm.cards);
        localStorageService.set('cardOrderCurrentCard', vm.currentCard);
        $state.go('signup.signin');
      }
    }
  }

}]);
